import { useQuery } from '@tanstack/react-query'
import { fetchPortfolioValue } from '@/lib/polymarketApi'

/**
 * Polymarket Data API: total position value (portfolio value in USDC) for an address.
 * Distinct from USDC balance: this is the value of conditional token positions.
 */
export function usePortfolioValue(address: string | null | undefined) {
  const enabled = Boolean(address && typeof address === 'string' && address.startsWith('0x'))
  const { data, isLoading, isError } = useQuery({
    queryKey: ['portfolioValue', address ?? ''],
    queryFn: () => fetchPortfolioValue(address!),
    enabled,
    staleTime: 5_000,
    refetchInterval: 5_000,
  })
  return { value: data ?? null, isLoading: enabled && isLoading, isError }
}
